import { dateToShow } from '@/helpers/dates'
import moment from 'moment'

const lastDay = () => {
  let date = new Date()
  let makeLastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0)
  let lastDay = moment(makeLastDay).format('DD/MM/YYYY')
  return lastDay
}

export default {
  prepareShow (agenda) {
    this.lastday = lastDay()
    agenda.validate = dateToShow(agenda.validate)

    if (agenda.validate !== this.lastday) {
      this.ishidden = true
    }

    return agenda
  }
}



// WEBPACK FOOTER //
// ./src/app/professional/dashboard/professional/gadget/components/agendas-statistics/resources/methods.js